import * as React from 'react'

const MetaTags = ({
  title,
  description,
  showSlogan,
  twitterCardStyle,
  metaImage,
  canonical,
  noIndex,
}: {
  title: string
  description: string
  showSlogan: boolean
  twitterCardStyle: string
  metaImage: string
  canonical: { relative: string } | { absolute: string } | 'none'
  noIndex?: boolean
}): JSX.Element => {
  const getTitle = () => (showSlogan ? `${title} End-To-End Encrypted Notes App` : title)

  const canonicalLink =
    canonical === 'none'
      ? null
      : 'absolute' in canonical
      ? canonical.absolute
      : `${process.env.HOST_NAME}${canonical.relative}`

  return (
    <>
      <meta charSet="UTF-8" />
      <meta content="text/html; charset=UTF-8" httpEquiv="Content-Type" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" type="image/png" />
      <base href="/" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      {noIndex ? (
        <meta name="robots" content="noindex" />
      ) : (
        <meta name="robots" content="index, follow, max-snippet:-1, max-image- preview:large, max-video-preview:-1" />
      )}

      <title>{getTitle()}</title>
      <meta content={getTitle()} name="title" />
      <meta content={getTitle()} name="apple-mobile-web-app-title" />
      <meta content={getTitle()} name="application-name" />
      <meta content={getTitle()} name="twitter:title" />
      <meta content={getTitle()} name="og:title" />
      <meta content="@standardnotes" name="twitter:site" />
      <meta content={twitterCardStyle} name="twitter:card" />
      <meta content={description} name="description" />
      <meta content={description} name="twitter:description" />
      <meta content={description} name="og:description" />
      <meta name="twitter:image" content={metaImage} />
      <meta name="og:image" content={metaImage} />
      {canonicalLink && <link rel="canonical" href={canonicalLink} />}
    </>
  )
}

MetaTags.defaultProps = {
  showSlogan: false,
  twitterCardStyle: 'summary',
  metaImage: 'https://assets.standardnotes.com/media/SN-Icon-500.png',
}

export default MetaTags
